import { render, staticRenderFns } from "./allTopic.vue?vue&type=template&id=37de6d46&scoped=true&"
import script from "./allTopic.vue?vue&type=script&lang=js&"
export * from "./allTopic.vue?vue&type=script&lang=js&"
import style0 from "./allTopic.vue?vue&type=style&index=0&id=37de6d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de6d46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37de6d46')) {
      api.createRecord('37de6d46', component.options)
    } else {
      api.reload('37de6d46', component.options)
    }
    module.hot.accept("./allTopic.vue?vue&type=template&id=37de6d46&scoped=true&", function () {
      api.rerender('37de6d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/allTopic.vue"
export default component.exports